export const ZIP_CODE_REGEX = /^[0-9]{5}$/;
export const NAME_FIELD_REGEX = (length = 50) =>
  `[a-zA-Z_ '\\\`\\-]{1,${length}}`;
export const SEGMENT_PRODUCT_NAME = 'renters-insurance';

export enum CurrentStep {
  StartApplication = 'StartApplication',
  QuoteInformation = 'QuoteInformation',
  CoverageDetails = 'CoverageDetails',
}

export enum ContactSupportId {
  companyDropdown = '1',
  covie = '2',
  organisationStartApplication = '3',
  usePrefillApplication = '4',
  building = '5',
  organisation = '6',
  complianceHelpers = '7',
  coverageDetailsInnerContent = '8',
  coverageDetailsOne = '9',
  coverageDetailsTwo = '10',
  paymentMSIUpdateQuote = '11',
  paymentMSIHandleEvent = '12',
  paymentMSICompletePurchase = '13',
  showError = '14',
  quoteInformation = '15',
  startApplication = '16',
}
